import { PROFILE_GENDER } from '../../../models/profile/constants/gender'

export const PROFILE_GENDER_TO_SEARCH_MALE_QUERY_ARR = [
  ' men’s',
  ' men',
  'men’s ',
  'for men',
  'male',
  'testo',
  'upper',
  'arms'
]

export const PROFILE_GENDER_TO_SEARCH_FEMALE_QUERY_ARR = [
  'women',
  'female',
  'postpartum',
  'pregan',
  'booty',
  'glute',
  'butt',
  'slim',
  'tone',
  'sexy'
]

export const PROFILE_GENDER_TO_SEARCH_QUERY_ARR_TO_IGNORE = {
  [PROFILE_GENDER.MALE]: PROFILE_GENDER_TO_SEARCH_FEMALE_QUERY_ARR,
  [PROFILE_GENDER.FEMALE]: PROFILE_GENDER_TO_SEARCH_MALE_QUERY_ARR,
  [PROFILE_GENDER.OTHER]: [
    'men',
    'women',
    'male',
    'female',
    'postpartum',
    'pregan',
    'testo'
  ]
}

export const PROFILE_GENDER_TO_SEARCH_QUERY_ARR = {
  [PROFILE_GENDER.MALE]: PROFILE_GENDER_TO_SEARCH_MALE_QUERY_ARR,
  [PROFILE_GENDER.FEMALE]: PROFILE_GENDER_TO_SEARCH_FEMALE_QUERY_ARR,
  [PROFILE_GENDER.OTHER]: null
}
